import { getMaterialsAnalytics } from '../../api/analytics';
import {
  deleteTimer,
  getExelExport,
  getTimersCycleHistory,
  getTimersCycleHistoryTotal,
} from '../../api/timersCycleHistory';
import { downloadFile } from '../../utils';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_TIMERS_CYCLE_HISTORY_VALUE = 'CHANGE_TIMERS_CYCLE_HISTORY_VALUE';
export const CHANGE_TIMERS_CYCLE_HISTORY_SEVERAL_VALUES = 'CHANGE_TIMERS_CYCLE_HISTORY_SEVERAL_VALUES';
export const RESET_TIMERS_CYCLE_HISTORY_STORE = 'RESET_TIMERS_CYCLE_HISTORY_STORE';

export const GET_TIMERS_CYCLE_HISTORY = 'GET_TIMERS_CYCLE_HISTORY';
export const GET_TIMERS_CYCLE_HISTORY_SUCCESS = 'GET_TIMERS_CYCLE_HISTORY_SUCCESS';
export const GET_TIMERS_CYCLE_HISTORY_ERROR = 'GET_TIMERS_CYCLE_HISTORY_ERROR';

export const DELETE_TIMERS_CYCLE_HISTORY = 'DELETE_TIMERS_CYCLE_HISTORY';
export const DELETE_TIMERS_CYCLE_HISTORY_SUCCESS = 'DELETE_TIMERS_CYCLE_HISTORY_SUCCESS';
export const DELETE_TIMERS_CYCLE_HISTORY_ERROR = 'DELETE_TIMERS_CYCLE_HISTORY_ERROR';

export const LOAD_TIMERS_FILE = 'LOAD_TIMERS_FILE';
export const LOAD_TIMERS_FILE_SUCCESS = 'LOAD_TIMERS_FILE_SUCCESS';
export const LOAD_TIMERS_FILE_ERROR = 'LOAD_TIMERS_FILE_ERROR';

export const GET_TIMERS_CYCLE_HISTORY_ANALYTIC = 'GET_TIMERS_CYCLE_HISTORY_ANALYTIC';
export const GET_TIMERS_CYCLE_HISTORY_ANALYTIC_SUCCESS = 'GET_TIMERS_CYCLE_HISTORY_ANALYTIC_SUCCESS';
export const GET_TIMERS_CYCLE_HISTORY_ANALYTIC_ERROR = 'GET_TIMERS_CYCLE_HISTORY_ANALYTIC_ERROR';

export const downloadTimersFile = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: LOAD_TIMERS_FILE });
    try {
      const response = await getExelExport(params);
      const { success, results } = response;
      if (success) {
        response.code !== 202 && downloadFile(results, 'application/zip');
        dispatch({ type: LOAD_TIMERS_FILE_SUCCESS });
        if (actions.onSuccess) {
          actions.onSuccess(response);
        }
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: LOAD_TIMERS_FILE_ERROR });
      if (actions.onError) {
        actions.onError(error.message);
      }
    }
  };
};

export const getTimersAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_TIMERS_CYCLE_HISTORY_ANALYTIC, payload: params.cursorDirection === 'FIRST' });
      try {
        const totalParams = {
          startTime: params.startEventTime,
          endTime: params.endEventTime,
          restaurantUuid: params.restaurantsUuid,
          materials: params.materials,
        };
        
        if (params.correctnessTypes) {
          totalParams.correctnessTypes = params.correctnessTypes;
        }
        
        const [response, totalResponse] = await Promise.all([
          getMaterialsAnalytics(params, abortController.signal),
          getTimersCycleHistoryTotal(totalParams, abortController.signal),
        ]);

        const { success, results } = response;
        const { success: totalSuccess, results: total } = totalResponse;

        if (success && totalSuccess && !abortController.signal.aborted) {
          dispatch({ type: GET_TIMERS_CYCLE_HISTORY_ANALYTIC_SUCCESS, payload: { results, total }, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_TIMERS_CYCLE_HISTORY_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const getTimersAction = (function () {
  let prevController;

  return (params, actions = null) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_TIMERS_CYCLE_HISTORY, payload: params.cursorDirection === 'FIRST' });
      try {
        const response = await getTimersCycleHistory(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_TIMERS_CYCLE_HISTORY_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          actions?.onError(error.message);
          dispatch({ type: GET_TIMERS_CYCLE_HISTORY_ERROR, params });
        }
      }
    };
  };
})();

export const deleteTimerAction = (uuid, actions = null) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_TIMERS_CYCLE_HISTORY });
    try {
      const response = await deleteTimer(uuid);
      const { success } = response;
      if (success) {
        actions?.onSuccess();
        dispatch({ type: DELETE_TIMERS_CYCLE_HISTORY_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions?.onError(error.message);
      dispatch({ type: DELETE_TIMERS_CYCLE_HISTORY_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_TIMERS_CYCLE_HISTORY_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_TIMERS_CYCLE_HISTORY_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_TIMERS_CYCLE_HISTORY_STORE,
});
